import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { MilestoneIcon } from "@common/milestoneIcon";
import { UseCases } from "@planzone/core";
import { useAuthentication } from "@planzone/view-models";
import { Identifiable, Milestone } from "@planzone/dto";
import { useModal } from "@root/client/modal";
import { Props } from "./types";
import styles from "./styles.scss";

function isMilestoneLate({ endDate }: Identifiable<Milestone>) {
  return endDate && new Date(endDate) < new Date();
}

function isMilestoneDone({ state }: Identifiable<Milestone>) {
  return state === "DONE";
}

function Milestones({ milestones, placeholder }: Props) {
  const { t } = useTranslation();
  const { pushView } = useModal();

  return (
    <div className={styles.milestones}>
      {milestones.length === 0 ? (
        <div className={styles.placeholder}>{<p>{placeholder}</p>}</div>
      ) : (
        <div className={styles.list}>
          {milestones.map((milestone) => {
            const isDone = isMilestoneDone(milestone);

            return (
              <div
                key={milestone.uuid}
                className={classNames(styles.milestone, {
                  [styles.late]: isMilestoneLate(milestone) && !isDone,
                  [styles.done]: isDone,
                })}
                onClick={() =>
                  pushView({
                    key: UseCases.retrieveMilestone,
                    data: { milestone },
                  })
                }
              >
                <div>
                  <MilestoneIcon
                    milestone={milestone}
                    className={styles.icon}
                  />
                  <p className={styles.name}>{milestone.name}</p>
                </div>
                {isDone ? (
                  <p className={styles.endDate}>
                    {new Date(milestone.completedAt).toLocaleDateString()}
                  </p>
                ) : milestone.endDate ? (
                  <p className={styles.endDate}>
                    {new Date(milestone.endDate).toLocaleDateString()}
                  </p>
                ) : (
                  <p className={styles.endDate} />
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export { Milestones };
